export default {
  CREATE_TEAM: 'createTeam',
  UPDATE_TEAM_NAME: 'updateTeamName',
  UPDATE_TEAM_DATA: 'updateTeamData',
  UPDATE_STORY_DATA: 'updateStoryData',
  UPLOAD_IMAGE: 'uploadImage',
  CHECK_SHORT_NAME: 'checkShortName',
  UPDATE_TEAM_SETTINGS: 'updateTeamSettings',
  UPDATE_TEAM_MEMBERS_TARGET: 'updateTeamMembersTarget',
  UPDATE_GIFT_AID_PREFERENCES: 'updateGiftAidPreferences',
  EVENT_SEARCH: 'eventSearch',
  GET_EVENT_DETAILS: 'fetchEventDetails',
  GET_FUNDRAISING_PAGES: 'fetchFundraisingPages',
  LINK_FUNDRAISING_PAGE: 'linkFundraisingPage',
  GET_MEMBERS_LIST: 'fetchMembersList',
  GET_FRP_DATA: 'fetchFrpData',
  CREATE_FUNDRAISING_PAGE: 'createFundraisingPage',
  UPDATE_SHORT_NAME: 'updateShortName',
  UPDATE_FUNDRAISING_DATA: 'updateFundraisingData',
  ACTIVATE_PAGE: 'activatePage',
  CHECK_FRP_SHORT_NAME: 'checkFrpShortName',
  UPDATE_MEMBERSHIP_POLICY: 'updateMembershipPolicy',
  UNLINK_MEMBER: 'unlinkMember',
  DELETE_TEAM: 'deleteTeam',
  FETCH_GDPR_CONSENTS: 'fetchGDPRConsents',
  UPDATE_GDPR_CONSENTS: 'updateGDPRConsents',
  SUBMIT_TEAM_NAME: 'SUBMIT_TEAM_NAME',
  CREATE_EVENT: 'CREATE_EVENT',
  UPDATE_TEAM_LOCKS: 'UPDATE_TEAM_LOCKS',
  SUBMIT_TEAM_DATA: 'SUBMIT_TEAM_DATA',
};
